const constants = {
    TIMEOUT_REQUEST: 60000,
    TIMEOUT_OTP: 120,
    TIMEOUT_VERI_CODE: 120,
    MAX_SIZE_UPLOAD_FILE: 5 * 1024 * 1024,// 5mb
    PHONE_REGEX: /^\+?[0-9]{10,12}$/i,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/i,
};
export default constants;
